export default function NoPage() {
  return "Sayfa Bulunamadı";
}
